import Vue from 'vue'

export default {
	methods: {
		addZeroTime(t) {
			if (t.length == 1) {
				return '0' + t;
			} else {
				return t;
			}
		},
		strToFloat(d: any) {
			if (d != '' && d != null) {
				return parseFloat(d)
			} else {
				return null
			}
		},
		NulltoStr(d: any) {
			if (d != '' && d != null) {
				return d
			} else {
				return ''
			}
		},
		Float2Decimal(d: any) {
			if (d != '' && d != null) {
				return d.toFixed(2)
			} else {
				return '0.00'
			}
		},
		RandomString(length: any) {
			var text = ''
			var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			for (var i = 0; i < length; i++) text += possible.charAt(Math.floor(Math.random() * possible.length))
			return text
		},
		GenDateTimeID() {
			let tnow = new Date()
			let DateNow = tnow.getFullYear() + (tnow.getMonth() + 1) + tnow.getDate()
			let Hours = ''
			let Minutes = ''
			let Seconds = ''
			if (tnow.getHours().toString().length == 1) {
				Hours = '0' + tnow.getHours().toString()
			} else {
				Hours = tnow.getHours().toString()
			}

			if (tnow.getMinutes().toString().length == 1) {
				Minutes = '0' + tnow.getMinutes().toString()
			} else {
				Minutes = tnow.getMinutes().toString()
			}

			if (tnow.getSeconds().toString().length == 1) {
				Seconds = '0' + tnow.getSeconds().toString()
			} else {
				Seconds = tnow.getSeconds().toString()
			}

			return DateNow + Hours + Minutes + Seconds
		},
		Arrayfilter(arData, ch) {
			var value = []

			if (arData != null) {
				value = arData.filter((item) => {
					return item.id == ch
				})
			} else {
				value = []
			}

			return value
		},
		UserModulRightCheck(arData, ch) {
			let obj = arData.find((data) => data.modul === ch)
			return obj
		},
		UserHOSxPRightCheck(arData, ch) {
			let obj = arData.find((data) => data === ch)
			return obj
		},
		IpfsListDataArrayfilter(arData, ch) {
			let bb = []
			let i = 0

			arData.find(function (value, index) {
				// Delete element 5 on first iteration
				if (value.ipfs_file_user === ch) {
					bb[i] = value
					i = i + 1
				}
			})

			return bb
		},
		IPDListDataArrayfilter(arData, ch) {
			let bb = []
			let i = 0

			arData.find(function (value, index) {
				// Delete element 5 on first iteration
				if (value.datas.file_user_log === ch) {
					bb[i] = value
					i = i + 1
				}
			})

			return bb
		},
		VNarrayFind(arData, ch) {
			let value = []
			if (arData != null) {
				value = arData.find((data) => data.vn === ch)
			} else {
				value = []
			}
			return value
		},
		HistoryFind(arData, ch) {
			let value = []
			if (arData != null) {
				value = arData.find((data) => data === ch)
			} else {
				value = []
			}
			return value
		},
		OpenWindowWithPost(url, windowoption, name, params) {
			var form = document.createElement("form");
			form.setAttribute("method", "post");
			form.setAttribute("action", url);
			form.setAttribute("target", name);

			for (var i in params) {
				if (params.hasOwnProperty(i)) {
					var input = document.createElement('input');
					input.type = 'hidden';
					input.name = i;
					input.value = params[i];
					form.appendChild(input);
				}
			}

			document.body.appendChild(form);

			//note I am using a post.htm page since I did not want to make double request to the page 
			//it might have some Page_Load call which might screw things up.
			window.open("post.htm", name, windowoption);

			form.submit();

			document.body.removeChild(form);
		},
		SymptomArrayfilter(arData, ch) {
			var value = []

			if (arData != null) {
				value = arData.filter((item) => {
					return item.value == ch
				})
			} else {
				value = []
			}

			return value
		}

	}
}
